import type { ApiUser } from '#/api/userEnvironment/types/ApiUserEnvironment';
import { Icon } from '#/components/Icon/Icon';
import { useI18n } from '#/i18n/hooks/useI18n';
import {
  orgDashboardPostAListingPath,
  orgDashboardRootPath,
} from '#/modules/orgDashboard/routing/orgDashboard.paths';
import { useRouteParams } from '#/routing/hooks/useRouteParams';

import { LayoutHeaderButton } from './Button/LayoutHeaderButton';
import {
  LayoutHeaderPostListingButtonContent,
  LayoutHeaderPostListingButtonHolder,
} from './LayoutHeader.styled';

type Props = {
  user: ApiUser;
};

export function LayoutHeaderPostListingButton({ user }: Props) {
  const { i18n } = useI18n();
  const { orgId } = useRouteParams(orgDashboardRootPath);
  const org = user.orgs.find((o) => o.id === orgId);

  if (
    !org ||
    !org.isAllowedToPost ||
    !org.canTakeAdminActions ||
    org.isFrozen
  ) {
    return null;
  }

  return (
    <LayoutHeaderPostListingButtonHolder>
      <LayoutHeaderButton
        variant="blue"
        data={{
          type: 'link-with-state',
          to: orgDashboardPostAListingPath.with({ orgId: org.id }),
          state: { from: `/admin/${org.id}` },
          clickActions: {
            track: {
              name: 'Post a Listing',
              properties: { context: 'Dashboard' },
            },
          },
        }}
        qaId="post-listing-link"
      >
        <LayoutHeaderPostListingButtonContent>
          <Icon name="plus" size={16} />
          {i18n('Post a Listing')}
        </LayoutHeaderPostListingButtonContent>
      </LayoutHeaderButton>
    </LayoutHeaderPostListingButtonHolder>
  );
}
